import { TRUST_AND_SECURITY_URL } from "constants/urls"
import { usePageAssets } from "hooks/usePageAssets"
import Button from "components/ui/Button"
import Container from "components/ui/Container"
import Divider from "components/ui/Divider"
import Heading from "components/ui/Heading"
import SplitContainer from "components/ui/Layout/SplitContainer"

function FeaturesLockupSection() {
  const { getAsset } = usePageAssets()
  const image1 = getAsset("product-sql-databases")
  const image2 = getAsset("product-security-governance-reliability")
  return (
    <Container section>
      <Divider className="mb-10 xl:mb-0" />
      <SplitContainer
        className="lg:py-10 xl:py-40"
        image={image1}
        imageClassName="mt-5 lg:mt-0 max-w-xl mx-auto"
      >
        <Heading
          title="Create datasets from most SQL databases"
          subtitle={
            <>
              Instantly connect with popular SQL databases and create physical
              and virtual datasets. Datasets let you have unified metric
              definitions, enabling a truly self-serve data exploration
              experience.
            </>
          }
        />
      </SplitContainer>
      <Divider className="my-14 xl:my-0" />
      <SplitContainer
        className="lg:py-10 xl:py-40"
        image={image2}
        imageClassName="mt-5 lg:mt-0 max-w-xl mx-auto"
        reversed
      >
        <Heading
          title="Security, governance, and reliability at scale"
          subtitle={
            <>
              Own your data and define who has access. Preset Cloud comes with
              configurable role-based access and SSO support. And we are SOC
              2-certified.
            </>
          }
        />
        <Button
          className="mt-7"
          color="green"
          size="medium"
          href={TRUST_AND_SECURITY_URL}
          trackClick="Learn More (footer)_Product"
          shadow
        >
          Learn More
        </Button>
      </SplitContainer>
      <Divider className="mt-8 xl:-mt-8" />
    </Container>
  )
}

export default FeaturesLockupSection
